"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordHdnService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordHdnService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordHdnService.instance) {
      return CordHdnService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordHdnService.instance = this;
  }
  sendDocument(documentId, requestObject) {
    return this.post('documents/' + documentId + '/send', requestObject);
  }
  sendAllDocuments(applicationId, requestObject) {
    return this.post(`applications/${applicationId}/documents/send`, requestObject);
  }
  publishDocuments(applicationId, requestObject) {
    return this.post(`applications/${applicationId}/documentList/publish`, requestObject);
  }
  publishOxMessages(applicationId, requestObject) {
    return this.post(`applications/${applicationId}/messages/ox/forward`, requestObject);
  }
  sendAxMessage(applicationId, newMessage) {
    return this.post(`applications/${applicationId}/messages`, newMessage);
  }
  createHdnDossier(applicationId) {
    return this.patch(`applications/${applicationId}/createHdnDossier`, null);
  }
  createHdnRecord(hdnRecord) {
    return this.post('hdnRecord/create', hdnRecord);
  }
  patchHdnRecordApplication(applicationId, hdnPatchData) {
    return this.patch('hdnRecord/application/' + applicationId, hdnPatchData);
  }
  getHdnRecord(applicationId) {
    return this.get(`hdnRecord/application/${applicationId}`);
  }
  getAxModelAsXml(application) {
    return this.post('messages/axModelAsXml', application);
  }
}
exports.CordHdnService = CordHdnService;
CordHdnService.instance = null;
